import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';

export default function isActionConfirmationsEnabled() {
    return getFallbackValueIfNull(
        getStore().actionConfirmationsEnabled,
        getUserConfiguration().UserOptions.ShowNotificationBar
    );
}
